// extracted by mini-css-extract-plugin
export default {"document-wrapper":"document-wrapper-ef26","loading":"loading-c79e","download-container":"download-container-222c","fullScreen":"fullScreen-f88f"};